// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o0hQqWUP_OrpkY {
  z-index: 10;
  margin: var(--ds-space-0, 0) var(--ds-space-025, 2px);
  border-radius: 16px;
  background-color: var(--ds-surface-raised, #ffffff);
  padding: var(--ds-space-075, 6px);
  color: var(--ds-text-accent-purple, #635394);
}
.o0hQqWUP_OrpkY:hover {
  background-color: var(--ds-surface-raised-hovered, #f1f2f4);
}
.o0hQqWUP_OrpkY:active {
  background-color: var(--ds-surface-raised-pressed, #dcdfe4);
}
.o0hQqWUP_OrpkY.oo8FUDOMwTgiZ1 {
  background-color: var(--ds-background-accent-purple-subtlest-hovered, #dfd8fd);
  color: var(--ds-text-accent-purple, #635394);
}
.o0hQqWUP_OrpkY.oo8FUDOMwTgiZ1:hover,
.o0hQqWUP_OrpkY.oo8FUDOMwTgiZ1:focus,
.o0hQqWUP_OrpkY.oo8FUDOMwTgiZ1:active {
  background-color: var(--ds-background-accent-purple-subtlest-hovered, #dfd8fd);
}
.o0hQqWUP_OrpkY:hover,
.o0hQqWUP_OrpkY:focus,
.o0hQqWUP_OrpkY:active {
  background-color: var(--ds-background-accent-purple-subtlest, #f5f2ff);
  color: var(--ds-text-accent-purple, #635394);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mirrorCardFreeBadge": `o0hQqWUP_OrpkY`,
	"mirrorCardFreeBadge--selected": `oo8FUDOMwTgiZ1`
};
export default ___CSS_LOADER_EXPORT___;
